import React from 'react';
import { type Clinician,useClinicians } from '@features/organizations';
import { Autocomplete, TextField } from '@mui/material';

interface ProviderPickerProps {
  value?: string;
  onChange: (providerId: string) => void;
}

export const ProviderPicker: React.FC<ProviderPickerProps> = ({ value, onChange }) => {
  const { clinicians, isLoading } = useClinicians();

  const selectedClinician = clinicians.find(c => c.userId === value) ?? null;

  return (
    <Autocomplete<Clinician>
      options={clinicians}
      loading={isLoading}
      value={selectedClinician}
      onChange={(_event, newValue) => {
        if (newValue) {
          onChange(newValue.userId);
        }
      }}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, val) => option.userId === val.userId}
      renderInput={params => <TextField {...params} label="Provider" />}
    />
  );
};

export default ProviderPicker;
